import React, { useCallback, useMemo } from 'react';
import { isNull } from 'lodash/fp';

import { deleteFewShotDocumentStarted, getDocumentToDelete, getIsDeleting } from './store';
import { useAppDispatch, useAppSelector } from '../../../../hooks/react-redux';
import { Document } from '../../../shared/icons';
import { TypeDeleteConfirmationModal } from '../../../shared/modal/TypeDeleteConfirmationModal';

interface DeleteFewShotDocumentModalProps {
    closeModal: () => void;
}

export const DeleteFewShotDocumentModal: React.FC<DeleteFewShotDocumentModalProps> = ({ closeModal }) => {
    const dispatch = useAppDispatch();
    const isDeleting = useAppSelector(getIsDeleting);
    const documentToDelete = useAppSelector(getDocumentToDelete);
    const deleteFewShotDocument = useCallback(() => dispatch(deleteFewShotDocumentStarted()), [dispatch]);

    const documentDescription = useMemo(() => documentToDelete?.documentDescription || '', [documentToDelete]);
    const headerLabel = useMemo(() => `Delete Few Shot Example "${documentDescription}"?`, [documentDescription]);

    if (isNull(documentToDelete)) {
        return null;
    }

    return (
        <TypeDeleteConfirmationModal
            isOpen
            closeModal={closeModal}
            deleteAction={deleteFewShotDocument}
            isDeleting={isDeleting}
            headerLabel={headerLabel}
            name={documentDescription}
            testId='access-group'
            icon={Document}
            warning='Once deleted, this few shot document will be archived. It will not be able to be used for few shot training.'
        />
    );
};
